<div class="container-fluid">
    <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-7">
            <br>
            <h3>Auri Graduaciones - Registro</h3>
        </div>
        <div class="col-lg-4 col-md-3">
            <br>
            <a href="inicio">
                <p class="text-end">Si ya te registraste da click en el siguiente botón
                <button class="btn btn-danger">Iniciar Sesión</button></p><br>
            </a>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-10">
            <div class="row">
                <div class="col-lg-2 col-md-3">
                    <img src="assets/img/auri.png" width="100%">
                </div>
                <div class="col-lg-3 col-md-6">
                    <br>
                    <p><span class="amarillo2 bold">Grupo:</span> {{grupo.nombre}}<br>
                        <span class="amarillo2 bold">Carrera:</span> {{grupo.carrera}}<br>
                        <span class="amarillo2 bold">Escuela:</span> {{grupo.escuela}}<br>
                    </p>
                </div>

                <div class="col-lg-7 col-md-7">
                    <div *ngIf="contenido.video_registro;">
                        <video src="{{environment}}{{contenido.video_registro}}"  width="100%" controls>
                            Tu navegador no admite el elemento <code>video</code>.
                        </video>
                    </div>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-lg-4 col-md-4">
                    <span class="amarillo2 bold">Nombre:</span><br>
                    <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="formulario2.nombre"><br>
                </div>

                <div class="col-lg-4 col-md-4">
                    <span class="amarillo2 bold">Apellido Paterno:</span><br>
                    <input type="text" class="form-control" placeholder="Apellido Paterno" [(ngModel)]="formulario2.apellidos"><br>
                </div>

                <div class="col-lg-4 col-md-4">
                    <span class="amarillo2 bold">Apellido Materno:</span><br>
                    <input type="text" class="form-control" placeholder="Apellido Materno" [(ngModel)]="formulario2.apellido_materno"><br>
                </div>

                <div class="col-lg-4 col-md-4">
                    <span class="amarillo2 bold">Celular:</span><br>            
                    <input type="number" class="form-control" placeholder="Celular" [(ngModel)]="formulario2.celular" required><br>
                </div>
                <div class="col-lg-4 col-md-4">
                    <span class="amarillo2 bold">Correo electrónico:</span><br>
                    <input type="text" class="form-control" placeholder="Correo electrónico" [(ngModel)]="formulario2.email"><br>
                </div>
                <div class="col-lg-4 col-md-4">
                    <span class="amarillo2 bold">Contraseña:</span><br>
                     <input type="password" class="form-control" placeholder="Contraseña" [(ngModel)]="formulario2.password"><br>
                </div>

                <div class="col-lg-4 col-md-4">
                    <span class="amarillo2 bold">Confirma tu contraseña:</span><br>
                    <input type="password" class="form-control" placeholder="Repite tu contraseña" [(ngModel)]="formulario2.password2"><br>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4"></div>
                <div class="col-lg-4">
                    <button class="btn btn-warning bold form-control blanco" (click)="validateRegistro();">Siguiente</button>
                </div>
                <div class="col-lg-4"></div>
            </div>
           
            <!-- <button class="btn btn-warning" (click)="agregarUsuarioGrupo(grupoid)">Agregar Usuario</button> -->
            <br><br>
        </div>
        <div class="col-lg-1"></div>
    </div>
</div>

<div id="terminosycondiciones" (click)="openModal(mymodal)"></div>
<ng-template #mymodal let-c="close" let-d="dismiss">
    <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">Términos y Condiciones</h4>
                <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">
                    <span aria-hidden="true">×</span>
                </button>
            </div>

            <div class="modal-body" >
                <div class="alert alert-danger" role="alert">
                    LOS DATOS QUE PROPORCIONAS EN EL FORMULARIO DE REGISTRO SERÁN UTILIZADOS PARA IMPRIMIR TUS PRODUCTOS.
                    <span class="bold">VERIFÍCALOS</span>

                    <p>
                        Nombre: {{formulario2.nombre}}<br>
                        Apellido Paterno: {{formulario2.apellidos}}<br>
                        Apellido Materno: {{formulario2.apellido_materno}}<br>
                        Celular: {{formulario2.celular}}<br>
                        Correo electrónico: {{formulario2.email}}<br>
                    </p>
                </div>
                
                <div>
                    <iframe src="assets/contratos/contrato_auri.pdf" style="width:100%;height:700px;"></iframe>
                  </div>

                <!-- <br>
                    <p>CONTRATO DE ADHESIÓN PARA LA ADQUISICIÓN DE BIENES Y
                        PRESTACION DE SERVICIOS, QUE CELEBRAN POR UNA PARTE “AURI
                        GRADUACIONES” REPRESENTADA POR EL C. GABRIEL GONZÁLEZ GÓMEZ,
                        A QUIEN EN LOS SUCESIVOS SE LE DENOMINARA “EL PROVEEDOR” Y POR
                        LA OTRA “EL CONTRATANTE”, AL TENOR DE LAS SIGUIENTES:</p>
                    
                    <p>
                        DECLARACIONES<br><br>
        
                        I.- DECLARA “EL PROVEEDOR”<br><br>
        
                        A). - El C. Gabriel González Gómez, mexicano, mayor de edad, con Registro
                        Federal de Contribuyentes GOGG840219CR07;<br><br>
        
                        B). - Que su domicilio fiscal se encuentra ubicado en calle Hidalgo no.109, Col.
                        Centro, Tula de Allende, C.P. 42800, con número telefónico 771-716-87-41, con
                        correo electrónico auri.graduaciones@gmail.com;<br><br>
        
                        C). - Que “AURI GRADUACIONES” es un establecimiento dedicada a prestar
                        servicios especializados para graduaciones, contando con toda la capacidad,
                        personal, infraestructura, servicios, experiencia y recursos necesarios para dar
                        cabal cumplimiento a las obligaciones generadas en el presente contrato y de
                        acuerdo a cada servicio contratado;<br><br>
        
                        II.- DECLARA EL “EL CONTRATANTE”<br><br>
        
                        A). -Llamarse como ha quedado plasmado en el proemio de este contrato, con
                        domicilio en… y el cual señala como domicilio convencional para todos los efectos
                        legales del presente Contrato.<br><br>
        
                        B). -Que tiene plena capacidad legal para la celebración del presente contrato,
                        acto jurídico y que no existe impedimento legal alguno, manifestando
                        expresamente obligarse en los términos y condiciones del mismo, por lo que, es
                        su voluntad adquirir los servicios que ofrece “EL PROVEEDOR”;<br><br>
        
                        C). -Que acepta las condiciones que estipula el presente contrato de adhesión;<br><br>
        
                        D). - Que ha recibido personalmente la información por parte de “EL
                        PROVEEDOR” y que acepta los TERMINOS Y CONDICIONES a los que se
                        sujetará su contratación de acuerdo las especificaciones establecidas en el
                        presupuesto de los bienes y servicios elegidos;<br><br>
        
                        D E F I N I C I O N E S<br><br>
        
                        A). - “EL PROVEEDOR”, es la persona física que ofrece los bienes y prestación de
                        servicios y que se denomina: “AURI GRADUACIONES”;<br><br>
                        
                        B). - “EL CONTRATANTE”, es la Persona física o moral, que contrata los Servicios
                        del proveedor relativos a la adquisición de bienes y prestación de servicios;<br><br>
        
                        C). -CONTRATO DE ADHESION, es el Acto Jurídico, por el cual, ambas partes se
                        obligan en los términos y condiciones en que se encuentra estipulado el presente
                        Instrumento Legal.<br><br>
        
                        D). - PAQUETES DE GRADUACIÓN, conjunto de bienes y servicios que son
                        convenidos entre el vendedor y el comprador para un fin específico y un precio
                        determinado, el cual podrá constar de fiesta, viaje, cuadros, anillos y fotografía, las
                        combinaciones de los servicios contratados se denominaran de la siguiente forma,
                        dependiendo de su alcance <br>
                        • Paquete 3 X 3<br>
                        • Paquete 2 X 2<br>
                        • Paquete de Individual <br><br>
        
                        E) PROMOCIONES GRUPALES, condiciones específicas que aplicaran cuando el
                        100 % de los contratantes elijan un determinado servicio, en el entendido de que
                        estas aplican solo cuando es el total de ellos y de acuerdo a lo manifestado en
                        cada hoja de servicio;<br><br>
        
                        F) COMITÉ Y REPRESENTANTES, serán hasta 4 integrantes elegidos por el
                        grupo, que lo representaran cuando se trate de servicios conjuntos y quienes
                        podrán decidir en su nombre sobre temas relativos a características y condiciones
                        para los paquetes de fiesta, viaje, cuadros y fotografía, así como información
                        general necesaria para procesar sus paquetes;<br><br>
        
                        D E C L A R A N A M B A S P A R T E S<br><br>
        
                        A). - Que reconocen la NATURALEZA JURIDICA del presente Contrato;<br><br>
        
                        B). -Que en este acto se reconocen expresamente la personalidad con que se
                        ostentan para todos los efectos legales a que haya lugar y manifiestan que, por
                        medio del presente instrumento legal se SUJETAN de manera LIBRE y
                        RESPONSABLE, en los términos y las condiciones a lo estipulado en el mismo,
                        siendo su LIBRE VOLUNTAD someterse al contenido de las siguientes:<br><br>
        
                        C L A U S U L A S<br><br>
        
                        PRIMERA. - CONSENTIMIENTO DE LAS PARTES, las Partes de común acuerdo
                        manifiestan su voluntad para celebrar el presente contrato cuya naturaleza jurídica
                        es la compraventa de paquete de graduación; por lo que “EL PROVEEDOR”, se
                        obliga a vender el paquete de graduación conforme a las especificaciones
                        establecidas en el presupuesto y el “CONTRATANTE”, se obliga a pagar como
                        contraprestación un precio cierto y determinado;<br><br>
        
                        SEGUNDA. -EL OBJETO del presente Contrato es la adquisición del paquete de
                        graduación o en su caso de productos o servicios individualizados cuyas
                        características y precio se detallan en el presupuesto que forma parte del presente
                        convenio, proporcionando al “CONTRATANTE” la asesoría relacionada con los
                        SERVICIOS ELEGIDOS, contando el “PROVEEDOR” con los siguientes:<br>
        
                        a).- Fiesta de graduación;<br>
                        b).- Viaje de graduación;<br>
                        c).- Venta de cuadros y anillos;<br>
                        d).- Toma de fotografias;<br>
        
                        <br><br>
                        TERCERA. –DESCRIPCIÓN DE SERVICIOS, PRODUCTOS, COSTOS Y FORMA
                        DE PAGO, a continuación, se describirán cada uno de los productos y servicios
                        ofrecidos y que podrán ser elegidos en paquete o de forma individual o la
                        combinación de varios, según los intereses y necesidades del “CONTRATANTE”
                        FIESTA DE GRADUACIÒN, descripción del servicio y condiciones:<br><br>
        
                        a). - “EL PROVEEDOR” gestionará y solicitará los servicios que se especificarán
                        en el anexo 1, denominado hoja de control de evento, relativo de este contrato por
                        cuenta de “EL CONTRATANTE”, de acuerdo a la disponibilidad de los mismos,
                        fungiendo como intermediario entre éste y las personas encargadas de
                        proporcionarlos directamente, consistiendo en la prestación de servicios para la
                        organización de un evento social, para el numero de personas definidas, en el
                        lugar elegido y con las condiciones del anexo respectivo;<br><br>
        
                        b). - El evento social se llevará a cabo en la fecha definida en el anexo respectivo
                        y con la duración ahí especificada, dentro de la duración del evento no se cuenta
                        el tiempo necesario que “El PROVEEDOR” requiera para la organización del
                        mismo.<br><br>
        
                        c).- “El PROVEEDOR” podrá cobrar una cantidad adicional, debidamente prevista
                        en el presupuesto, en el caso de que el evento prolongue su duración y/o el
                        número de invitados exceda del estipulado quedando con un costo que se definirá
                        en el anexo respectivo, por hora o fracción extra de ocupación y uso del inmueble,
                        y el costo por persona extra según lo estipulado en el anexo relativo a este
                        apartado, reservándose en todo momento la posibilidad de negar el servicio de no
                        haberse pedido con la antelación mínima acordada previo al evento;<br><br>
        
                        d). - El costo total que “El CONTRATANTE” debe solventar por la prestación del
                        servicio es el estipulado en el anexo relativo, no importando si el número de
                        asistentes al evento es inferior al acordado, debiendo ser cubierto en moneda
                        nacional y en la forma definida del anexo de que se trata, a la firma del presente
                        contrato, por concepto de anticipo, el restante en las fechas señaladas previo el
                        día de la celebración del evento; el “PROVEEDOR” expedirá el comprobante
                        respectivo con la siguiente información: nombre, razón social, fecha e importe del
                        anticipo, nombre y firma de la persona debidamente autorizada que recibe el
                        anticipo y el sello del establecimiento, el nombre del “CONTRATANTE”, la fecha,
                        hora y tipo de evento;<br><br>
        
                        e). - A efecto de tener seguridad en cuanto al número de asistentes al evento
                        social, el “CONTRATANTE” y el “PROVEEDOR” establecen como procedimiento
                        de control y verificación, el siguiente:
                        Ambas partes designarán, cada uno, a una persona de su confianza a efecto de
                        que sólo ingresen al lugar personas autorizadas por el “CONTRATANTE” para lo
                        cual, podrán pactar el uso de un boleto o contraseña, este, se responsabiliza del
                        excedente de personas que con su autorización expresa hayan ingresado al
                        evento;<br><br>
        
                        f). - El “CONTRATANTE” cuenta con un plazo de cinco días naturales posteriores a
                        la firma del presente contrato para cancelar la operación sin responsabilidad
                        alguna de su parte, en cuyo caso el “PROVEEDOR” se obliga a reintegrar las
                        cantidades que el consumidor le haya entregado, con la salvedad de el
                        equivalente a los gastos administrativos generados, monto señalado en el anexo
                        respectivo, lo anterior no será aplicable si la fecha de la prestación del servicio es
                        posterior a los días estipulados consistentes en 30 días naturales, pues ya se
                        habrán ocupado los recursos en pagar los servicios que garantizan la fecha del
                        evento;<br><br>
        
                        g). - El “PROVEEDOR” designara, de entre su personal, a una persona que será
                        quien durante la celebración del evento trate con el representante del consumidor
                        o con él mismo, los asuntos relacionados con la prestación del servicio, y se obliga
                        a que su personal atienda con esmero y cortesía a los asistentes al evento.
                        h).- En su caso el consumidor se obliga a cumplir con las disposiciones
                        reglamentarias que rijan el inmueble y a procurar que los asistentes al evento
                        observen la misma conducta. Para tal efecto el prestador del servicio deberá
                        entregar al consumidor una copia del reglamento respectivo o bien fijar en un lugar
                        visible sus disposiciones; Si los bienes destinados a la prestación del servicio
                        sufrieren un menoscabo por culpa o negligencia debidamente comprobada del
                        consumidor o de sus invitados, éste se obliga a cubrir los gastos de reparación de
                        los mismos, o en su caso, indemnizar a el prestador del servicio;<br><br>
        
                        i).- Las partes podrán acordar que el consumidor contrate libremente servicios
                        específicos relacionados con el evento social con otros prestadores de servicios
                        por así convenir a sus intereses, por lo que en caso de actualizarse dicho
                        supuesto el consumidor exime de toda responsabilidad a el prestador del servicio
                        en lo que respecta a dichos servicios en especifico.<br><br>
                        
                        j). - En caso de que el prestador del servicio se encuentre imposibilitado para
                        prestar el servicio por caso fortuito o fuerza mayor, como incendio, temblor u otros
                        acontecimientos de la naturaleza o hechos del hombre ajenos a la voluntad del
                        prestador del servicio, no se incurrirá en incumplimiento, por lo que no habrá pena
                        convencional en dichos supuestos;
                        Las fiestas tendrán una duración de 7hrs, por lo cual si el “CONTRATANTE”
                        excede este tiempo el “POVEEDOR” estará en pleno derecho de cobrar una
                        penalización de acuerdo a las horas extras del servicio que se hayan brindado.
                        Si el “CONTRATANTE” llegase a cancelar el evento no se hará devolución de
                        ningún tipo, y se tendrá que pagar una compensación al “PROVEEDOR” por la
                        falta de uso de “NO SHOW”.
                        <br><br>
                        VIAJE, descripción del servicio y condiciones:<br><br>
        
                        a).-“EL PROVEEDOR”gestionará y solicitará los servicios que se especificaran en
                        el anexo relativo de este contrato, ANEXO 2, denominado hoja de control de viaje,
                        por cuenta de “EL CONTRATANTE”, de acuerdo a la disponibilidad de los mismos,
                        a contratarlos fungiendo como intermediario entre éste y las personas encargadas
                        de proporcionarlos directamente como transportistas, hoteles, restaurantes,
                        arrendadoras de automóviles, servicios terrestres, guías de turistas, y/o cualquier
                        otro servicio a fin con el turismo, ya sea en el país o en el extranjero, el precio del
                        servicio, será el que se especifica detallado en el anexo relativo, de este contrato;
                        cuando se trate de viajes en el extranjero, se deberán presentar los precios en
                        moneda extranjera y en pesos, citando el tipo de cambio en que están calculados
                        éstos últimos, mencionando que el costo de ese servicio resulta de la conversión a
                        moneda nacional al momento en que se efectué el pago, sirviendo este tipo de
                        cambio para todos los efectos consiguientes, reembolsos incluidos;
                        “EL PROVEEDOR” se reserva el derecho de contratar por cuenta de “EL
                        CONTRATANTE”, los servicios a que se refiere este contrato precisamente en las
                        calidades o categorías contratadas, en cuanto a hoteles, transportes y
                        arrendadoras de autos se refiere, salvo que expresamente se convenga que estos
                        serán prestados invariablemente por un proveedor determinado. En caso de
                        modificación del prestador directo del servicio por otro de calidad equivalente, si
                        “EL CONTRATANTE” hace uso del servicio, se entenderá que consintió con dicha
                        modificación y no procederá reembolso alguno, aceptando que la intervención de
                        “EL PROVEEDOR” es exclusivamente con carácter de intermediario entre los
                        prestadores directos de los servicios solicitados;<br><br>
        
                        b). -Se hace del conocimiento de “EL CONTRATANTE” que si por causa de fuerza
                        mayor o caso fortuito, como, huelgas, fallas técnicas, actos de terrorismo,
                        fenómenos climáticos o hechos de la naturaleza que acontezcan antes o durante
                        el desarrollo de los servicios que impidan, demoren o de cualquier modo
                        obstaculicen que los prestadores de los servicios contratados no pudieran
                        proporcionarlos parcial o totalmente. “EL PROVEEDOR” solo gestionará por
                        cuenta de “EL CONTRATANTE” el reembolso que proceda, quedando relevada de
                        cualquier responsabilidad o compromiso, de igual manera quedará relevado de
                        responsabilidades por daños, heridas, accidentes, retrasos, irregularidades,
                        pérdidas o daños de objetos personales que sobrevengan durante la ejecución de
                        los servicios que pudiera ocurrirle a “EL CONTRATANTE” por no ser la persona
                        directamente encargada de prestar los servicios correspondientes y por ser solo
                        intermediaria entre éstas y él, sin embargo, auxiliara en todo momento en caso de
                        algún inconveniente que pudiera tener en su viaje, así como, coadyuvará para que
                        el prestador final le reembolse lo pagado, si así fuera el caso; reservándose el
                        derecho de retener un 10% del total de la cantidad pagada por la reservación
                        como gasto administrativo;<br><br>
        
                        c). - “EL CONTRATANTE” se compromete a respetar los reglamentos, reglas,
                        horarios o condiciones establecidas por cada uno de los prestadores de servicios
                        contratados por intermediación de “EL PROVEEDOR”, haciéndole del
                        conocimiento lo anterior y en consecuencia declina y se deslinda de cualquier
                        responsabilidad que pudiera derivar por su incumplimiento o negligencia, pudiendo
                        el “EL PROVEEDOR”, en cualquier momento y derivado del incumplimiento a las
                        disposiciones mencionadas, cancelar la continuidad del servicio en aras de la
                        protección e integridad de los contratantes;<br><br>
                    </p>
                -->
            </div>

            <div class="modal-footer">
                <input type="checkbox" [(ngModel)]="isChecked">Acepto los términos y condiciones<br>

                <!-- <button type="button" class="btn btn-success blanco bold" >Agregar Miembro <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg> </button> -->
              <button type="button" class="btn btn-warning" (click)="registrarUsuario(grupoid)">Registrarme</button>
            </div>
            
        </div>

    </div> 
</ng-template>